/**
 * @generated SignedSource<<19f39011ef416614287a15b824c213d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RedemptionTypeKey = "CHARITY" | "GIFT_CARD" | "MOBILE" | "PAYPAL" | "VENMO";
export type RedemptionOptionsInput = {
  redemptionType: RedemptionTypeKey;
};
export type RedemptionTypesCardQuery$variables = {
  optionsInput: RedemptionOptionsInput;
};
export type RedemptionTypesCardQuery$data = {
  readonly redemptionOptions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"useRedemptionOptionItemQuery_optionRef">;
      };
    }>;
  } | null;
  readonly redemptionTypes: {
    readonly " $fragmentSpreads": FragmentRefs<"RedemptionTypesButtons_redemptionTypes">;
  } | null;
  readonly walletBalance: {
    readonly " $fragmentSpreads": FragmentRefs<"CurrentEarningsCard_currentEarnings">;
  } | null;
};
export type RedemptionTypesCardQuery = {
  response: RedemptionTypesCardQuery$data;
  variables: RedemptionTypesCardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "optionsInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "optionsInput"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RedemptionTypesCardQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RedemptionTypes",
        "kind": "LinkedField",
        "name": "redemptionTypes",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RedemptionTypesButtons_redemptionTypes"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RedemptionOptionConnection",
        "kind": "LinkedField",
        "name": "redemptionOptions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RedemptionOptionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RedemptionOptionData",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useRedemptionOptionItemQuery_optionRef"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletBalance",
        "kind": "LinkedField",
        "name": "walletBalance",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CurrentEarningsCard_currentEarnings"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RedemptionTypesCardQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RedemptionTypes",
        "kind": "LinkedField",
        "name": "redemptionTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RedemptionType",
            "kind": "LinkedField",
            "name": "types",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RedemptionOptionConnection",
        "kind": "LinkedField",
        "name": "redemptionOptions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RedemptionOptionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RedemptionOptionData",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletBalance",
        "kind": "LinkedField",
        "name": "walletBalance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "amount",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subUnitAmount",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "849820435eaddf5083a424a65ba2d476",
    "id": null,
    "metadata": {},
    "name": "RedemptionTypesCardQuery",
    "operationKind": "query",
    "text": "query RedemptionTypesCardQuery(\n  $optionsInput: RedemptionOptionsInput!\n) {\n  redemptionTypes {\n    ...RedemptionTypesButtons_redemptionTypes\n    id\n  }\n  redemptionOptions(input: $optionsInput) {\n    edges {\n      node {\n        id\n        ...useRedemptionOptionItemQuery_optionRef\n      }\n    }\n  }\n  walletBalance {\n    ...CurrentEarningsCard_currentEarnings\n    id\n  }\n}\n\nfragment CurrentEarningsCard_currentEarnings on WalletBalance {\n  amount {\n    subUnitAmount\n  }\n  id\n}\n\nfragment RedemptionTypesButtons_redemptionTypes on RedemptionTypes {\n  types {\n    name\n    status\n    id\n  }\n  id\n}\n\nfragment useRedemptionOptionItemQuery_optionRef on RedemptionOptionData {\n  imageUrl\n  key\n  name\n}\n"
  }
};
})();

(node as any).hash = "4dba35c98c18f919594383485330c8c3";

export default node;
